<template>
  <div>
    <Header />
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div>
            <div class="accordion mb-3">
              <div class="card card-box">
                <div class="card-header">
                  <b-button
                    class="btn-link btn-lg d-flex align-items-center justify-content-between shadow-none"
                    v-b-toggle.accordion-1
                  >
                    <span>Tanda - tanda Vital</span>
                    <font-awesome-icon icon="angle-up" class="font-size-xl" />
                  </b-button>
                </div>
                <b-collapse id="accordion-1" visible accordion="accordion-example" role="tabpanel">
                  <div class="card-body">
                    <TandaVital />
                  </div>
                </b-collapse>
              </div>
              <div class="card card-box" ref="box_anamnesa">
                <div class="card-header">
                  <b-button
                    class="btn-link btn-lg d-flex align-items-center justify-content-between shadow-none"
                    v-b-toggle.accordion-2
                  >
                    <span>Anamnesis  <label style="color:red"> *</label></span>
                    <font-awesome-icon icon="angle-up" class="font-size-xl" />
                  </b-button>
                </div>
                <b-collapse id="accordion-2" accordion="accordion-example" role="tabpanel">
                  <div class="card-body">
                    <Anamnesa />
                  </div>
                </b-collapse>
              </div>
              <div class="card card-box" id="box_pemeriksaan_fisik">
                <div class="card-header">
                  <b-button
                    class="btn-link btn-lg d-flex align-items-center justify-content-between shadow-none collapsed"
                    v-b-toggle.accordion-3
                  >
                    <span>Pemeriksaan Fisik</span>
                    <font-awesome-icon icon="angle-up" class="font-size-xl" />
                  </b-button>
                </div>
                <b-collapse id="accordion-3" accordion="accordion-example" role="tabpanel">
                  <div class="card-body">
                    <Pemeriksaan ref="pemeriksaan" />
                  </div>
                </b-collapse>
              </div>
              <div class="card card-box" id="box_diagnosa">
                <div class="card-header">
                  <b-button
                    class="btn-link btn-lg d-flex align-items-center justify-content-between shadow-none collapsed"
                    v-b-toggle.accordion-4 >
                    <span>Diagnosis  <label style="color:red"> *</label></span>
                    <font-awesome-icon icon="angle-up" class="font-size-xl" />
                  </b-button>
                </div>
                <b-collapse id="accordion-4" accordion="accordion-example" role="tabpanel">
                  <div class="card-body">
                    <Diagnosa ref="diagnosa" />
                  </div>
                </b-collapse>
              </div>
              <div class="card card-box">
                <div class="card-header">
                  <b-button
                    class="btn-link btn-lg d-flex align-items-center justify-content-between shadow-none collapsed"
                    v-b-toggle.accordion-5
                  >
                    <span>Tata Laksana</span>
                    <font-awesome-icon icon="angle-up" class="font-size-xl" />
                  </b-button>
                </div>
                <b-collapse id="accordion-5" accordion="accordion-example" role="tabpanel">
                  <div class="card-body">
                    <TataLaksana ref="tata-laksana" />
                  </div>
                </b-collapse>
              </div>
              <div class="card card-box">
                <div class="card-header">
                  <b-button
                    class="btn-link btn-lg d-flex align-items-center justify-content-between shadow-none collapsed"
                    v-b-toggle.accordion-6
                  >
                    <span>Pemeriksaan Penunjang</span>
                    <font-awesome-icon icon="angle-up" class="font-size-xl" />
                  </b-button>
                </div>
                <b-collapse id="accordion-6" accordion="accordion-example" role="tabpanel">
                  <div class="card-body">
                    <PemeriksaanPenunjang ref="pemeriksaan-penunjang" />
                  </div>
                </b-collapse>
              </div>
            </div>
            <Footer ref="footer" />
            <div class="col-sm-12 d-flex justify-content-xl-end">
              <!-- <button class="btn btn-success m-2">Print</button> -->
              <button @click="exitButton()" class="btn btn-info m-2">Keluar</button>
              <button @click="saveButton()" class="btn btn-primary m-2 btn-spinner">
                <b-spinner v-show="saving_params.is_saving" class="btn-wrapper--icon" small></b-spinner>
                <span class="btn-wrapper--label">Simpan</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "./RekamMedis/Header.vue";
import TandaVital from "./RekamMedis/TandaVital";
import Pemeriksaan from "./RekamMedis/Pemeriksaan.vue";
import Diagnosa from "./RekamMedis/Diagnosa";
import TataLaksana from "./RekamMedis/TataLaksana";
import PemeriksaanPenunjang from "./RekamMedis/PemeriksaanPenunjang";
import Footer from "./RekamMedis/Footer.vue";
import axios from "axios";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faPenAlt,
  faKeyboard,
  faEraser,
  faAngleUp,
  faCamera,
  faFolder,
  faDownload,
  faEye,
  faTrash
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(
  faPenAlt,
  faKeyboard,
  faEraser,
  faAngleUp,
  faCamera,
  faFolder,
  faDownload,
  faEye,
  faTrash
);

import { mapGetters, mapActions } from "vuex";
import router from "@/router";
import startCase from "lodash/startCase";
import moment from "moment";
moment.locale('id');

export default {
  data: () => {
    return {
      beingSubmit: false,
    }
  },
  name: "RekamMedis",
  components: {
    Header,
    TandaVital,
    Anamnesa: () => import("./RekamMedis/Anamnesa"),
    Pemeriksaan,
    Diagnosa,
    TataLaksana,
    PemeriksaanPenunjang,
    Footer
  },
  beforeRouteLeave(to, from, next) {
    if (!this.beingSubmit && localStorage.getItem('IDLE') != 1 && to.name != 'riwayat-rekam-medis') {
      this.$swal({
        title: startCase("keluar"),
        html: `Apakah Anda yakin untuk keluar dari halaman ini?<br>Data yang telah ditulis tidak akan tersimpan.`,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: startCase("tidak"),
        confirmButtonText: startCase("ya")
      }).then(res => {
        if (res.value) {
          next();
        } else {
          next(false);
        }
      });
    } else {
      next();
    }
  },
  mounted() {
    Promise.all([
      this.cekPaket()
    ]);
  },
  methods: {
    // import the action from VUEX
    ...mapActions(["fetchData", "saveRekamMedis"]),
    async saveButton() {

      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false
      });
      return this.$swal({
        text: "Lanjutkan untuk simpan?",
        title: "Data yang sudah disimpan tidak dapat diubah!",
        showCancelButton: true,
        confirmButtonText: "Ya, lanjut pembayaran",
        cancelButtonText: "Tidak",
        reverseButtons: true
      }).then(async result => {
        if (result.value) {

          if(!this.validate()) {
            return this.handleError("Silakan lengkapi data Anda!");
          }

          if (!this.saving_params.is_next_konsul) {
            return this.handleError("Anda belum memilih durasi konsultasi!");
          }

          if (!this.saving_params.is_email_format) {
            return this.handleError("Silakan lengkapi Email Pengingat!");

          }

          if (!this.saving_params.is_number) {
            return this.handleError("No. Handphone wajib diisi!");
          }
          
          if (!this.saving_params.is_reminder) {
            return this.handleError("Pilih Reminder wajib diisi!");
          }

          // call vuex action (saveRekamMedis())
          const saving = await this.saveRekamMedis();

          if (!this.saving_params.is_saved) {
            this.validate();
            return this.handleError("Penyimpanan Rekam Medis gagal!");
          }

          if (!this.saving_params.is_kuotanotnull) {
            return this.handleError("Kuota Anda telah habis, silakan lakukan pembelian Paket untuk dapat melakukan aktivitas ini.");
          }
          this.beingSubmit = true;
          this.$swal
            .fire(
              "Rekam medis tersimpan!",
              "klik tombol ok untuk melanjutkan.",
              "success"
            )
            .then(res => {
              router.push({
                name: "pembayaran-tambah",
                params: {
                  bayar_id: saving.data.pembayaran.id
                }
              });
            });
        }
      });
    },
    handleError(message) {
      return this.$swal({
        type: "error",
        title: "Oops...",
        text: message
      });
    },
    exitButton() {
      this.beingSubmit = true;
      return this.$swal({
        html: "Apakah Anda yakin untuk keluar?<br>Data yang telah ditulis tidak akan tersimpan.",
        title: "Keluar",
        showCancelButton: true,
        confirmButtonText: "Ya",
        cancelButtonText: "Tidak",
        type: "warning"
      }).then(res => {
        if (res.value) {
          let transklinik_id = this.$router.currentRoute.params.transklinik_id;
          axios.put(`${this.url_api}/transaksi/${transklinik_id}`, {status: 'MENUNGGU'})
            .then(() => {
              router.push({
                path: "/rawat-jalan/antrean"
              });
            })
            .catch((err) => {
              // console.log(err);
            });
        }
      });
    },
    validate() {
      //only validate two field
      if (!this.postData.anamnesa_text) {
        this.$root.$emit('bv::toggle::collapse', 'accordion-2');
        this.$refs['box_anamnesa'].style.setProperty('border-color', 'red');
        return false;
      }
      else {
        this.$refs['box_anamnesa'].style.removeProperty('border-color');
      }

      if (!this.postData.kode_penyakit) {
        this.$root.$emit('bv::toggle::collapse', 'accordion-4');
        document.getElementById("box_diagnosa").style.setProperty('border-color', 'red');
        return false;
      } else if (this.postData.kode_penyakit[0].id == 34336 && !this.postData.diagnosa_text){
        this.$root.$emit('bv::toggle::collapse', 'accordion-4');
        document.getElementById("box_diagnosa").style.setProperty('border-color', 'red');
        return false;
      }

      return true;
    }
  },
  computed: mapGetters(["pasien", "saving_params", "postData"]),
  created() {
    this.fetchData();
  }
};
</script>

<style>
.dot {
  margin-right: 8px;
  height: 25px;
  width: 25px;
  border-radius: 50%;
  display: inline-block;
}

.icon {
  color: #cccccc;
}

.grow {
  transition: all 0.2s ease-in-out;
}

.grow:hover {
  transform: scale(1.3);
}

.active_tool {
  color: #464159;
  transform: scale(1.3);
}

.color_active {
  transform: scale(1.3);
}

.active_info {
  color: #3772d7;
  transform: scale(1.3);
}
</style>
